import HttpFactory from '../factory'

class EncountersModule extends HttpFactory<any[]> {
  private RESOURCE = '/encounters'
  private ENCOUNTER_COUNTER_PATH = '/encounters-counters'

  async get(id?: string) {
    if (!id) {
      let arr: any[] = []
      let nextPageUrl = '?pageSize=1000'
      do {
        await this.call<any>('GET', `${this.RESOURCE}/${nextPageUrl}`).then((response) => {
          arr = arr.concat(response.items)
          nextPageUrl = response.nextPageUrl
        })
      } while (nextPageUrl)
      return arr
    } else return await this.call<any>('GET', `${this.RESOURCE}/${id}`)
  }

  async getEncounter(id: string): Promise<{ items: any; nextPageUrl: string }> {
    return await this.call<any>('GET', `${this.RESOURCE}?patientId=${id}`)
  }

  async getAllEncounter(id: string) {
    let arr: any[] = []
    let nextPageUrl = `?patientId=${id}`
    do {
      await this.call<any>('GET', `${this.RESOURCE}/${nextPageUrl}`).then((response) => {
        arr = arr.concat(response.items)
        nextPageUrl = response.nextPageUrl
      })
    } while (nextPageUrl)
    return arr
  }

  async updateEncounter(id: string, data: any, params: any) {
    let url = `${this.RESOURCE}/${id}`
    if (params) {
      url += `?${new URLSearchParams(params).toString()}`
    }
    return await this.call<any>('PATCH', url, data)
  }

  async postEncounter(data: any) {
    return await this.call<any>('POST', `${this.RESOURCE}`, data)
  }

  async getEncounterCounters() {
    let arr: any[] = []
    let nextPageUrl = '?pageSize=1000'
    do {
      await this.call<any>('GET', `${this.ENCOUNTER_COUNTER_PATH}/patients/${nextPageUrl}`).then((response) => {
        arr = arr.concat(response.items)
        nextPageUrl = response.nextPageUrl
      })
    } while (nextPageUrl)
    return arr
  }
}

export default EncountersModule
